export default function Location() {
  const proximities = [
    { icon: 'ri-shopping-bag-line', distance: '7 quadras', name: 'Batel', color: 'bg-blue-100 text-blue-600' },
    { icon: 'ri-road-map-line', distance: 'Acesso direto', name: 'Av. Sete de Setembro', color: 'bg-green-100 text-green-600' },
    { icon: 'ri-route-line', distance: 'Acesso direto', name: 'Av. Marechal Floriano', color: 'bg-orange-100 text-orange-600' },
    { icon: 'ri-building-line', distance: 'Centro', name: 'Região Estratégica', color: 'bg-purple-100 text-purple-600' },
  ];

  return (
    <section id="localizacao" className="bg-gray-50 py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-serif font-bold text-5xl lg:text-6xl text-black mb-6">
            Av. Visconde de Guarapuava, 2807 - Centro
          </h2>
          <p className="text-gray-600 text-lg leading-relaxed">
            Inserido em região central estratégica de Curitiba, na Av. Visconde de Guarapuava, 
            com acesso direto à Av. Sete de Setembro e Av. Marechal Floriano Peixoto, e a 7 quadras do Batel.
          </p>
        </div>

        {/* Map */}
        <div className="mb-12 rounded-3xl overflow-hidden shadow-xl">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3603.0234567890123!2d-49.2733!3d-25.4284!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDI1JzQyLjIiUyA0OcKwMTYnMjMuOSJX!5e0!3m2!1spt-BR!2sbr!4v1234567890123!5m2!1spt-BR!2sbr"
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Localização ATMOS"
          ></iframe>
        </div>

        {/* Proximities Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {proximities.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow"
            >
              <div className={`w-16 h-16 ${item.color} rounded-full flex items-center justify-center mb-4`}>
                <i className={`${item.icon} text-3xl`}></i>
              </div>
              <p className="text-3xl font-bold text-black mb-2">{item.distance}</p>
              <p className="text-gray-700 font-medium">{item.name}</p>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 text-base">
            <i className="ri-map-pin-line mr-2"></i>
            Endereço completo: Av. Visconde de Guarapuava, 2807 - Centro, Curitiba - PR
          </p>
        </div>
      </div>
    </section>
  );
}
